import {post, postfile, downFile} from './http'
const baseUrl = '/api/admin/kmc/exampaper';
// 获取试卷信息列表
export const getAllExampaperInfo = v => post(`${baseUrl}/getAllExampaperInfo`, v.data, v.success, v.error)
// 编辑/新增试卷
export const saveOrUpdateExampaperInfo = v => post(`${baseUrl}/saveOrUpdateExampaperInfo`, v.data, v.success, v.error)
// 获取试卷信息
export const getExampaperInfo = v => post(`${baseUrl}/getExampaperInfo`, v.data, v.success, v.error)
// 转移试卷
export const moveExampaperToCate = v => post(`${baseUrl}/moveExampaperToCate`, v.data, v.success, v.error)
// 复制试卷
export const copyExampaper = v => post(`${baseUrl}/copyExampaper`, v.data, v.success, v.error)
// 删除试卷（可批量）
export const deleteExampaper = v => post(`${baseUrl}/deleteExampaper`, v.data, v.success, v.error)
// 获取试卷下试题列表
export const getExampaperQuesList = v => post(`${baseUrl}/getExampaperQuesList`, v.data, v.success, v.error)
// 试卷导入
export const importQuestionFile = v => postfile(`${baseUrl}/importQuestionFile`, v.data, v.success, v.error)
// 题库中导入
export const submitExampaperQuesImportInfo = v => post(`${baseUrl}/submitExampaperQuesImportInfo`, v.data, v.success, v.error)
// 编辑试题
export const updateCwKmcQuestionbankExampaperinfo = v => post(`${baseUrl}/updateCwKmcQuestionbankExampaperinfo`, v.data, v.success, v.error)
// 获取试题详情
export const getExamQuestionInfo = v => post(`${baseUrl}/getExamQuestionInfo`, v.data, v.success, v.error)
// 获取批阅列表
export const readExampaper = v => post(`${baseUrl}/readExampaper`, v.data, v.success, v.error)
// 获取批阅详情
export const getExamquestionInfoDetail = v => post(`${baseUrl}/getExamquestionInfoDetail`, v.data, v.success, v.error)
// 保存所有试卷
export const saveAllCwKmcQuestionbankuserexamquestioninfo = v => post(`${baseUrl}/saveAllCwKmcQuestionbankuserexamquestioninfo`, v.data, v.success, v.error)
// 提交试卷批阅信息
export const submitExamCheckinfo = v => post(`${baseUrl}/submitExamCheckinfo`, v.data, v.success, v.error)
// 导出试卷
export const exportExamPaperQuestion = v => downFile(`${baseUrl}/exportExamPaperQuestion`, v.data, v.success, v.error)







